var map = {
	"./video3-acacia.mp4": 1043,
	"./video3-beenleigh.mp4": 1044,
	"./video3-brisbane.mp4": 1045,
	"./video3-coopers.mp4": 1046,
	"./video3-goldcoast.mp4": 1047,
	"./video3-home.mp4": 1048,
	"./video3-ipswich.mp4": 1049,
	"./video3-rocklea.mp4": 1050,
	"./video3-sunnybank.mp4": 1051,
	"./video3-toowoomba.mp4": 1052,
	"./video3-underwood.mp4": 1053,
	"./video3-woodridge.mp4": 1054
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1042;